<div class="popup-msg" (click)="userDone()">
	<img src="{{ iconURL }}" alt="" class="popup-msg__icon" />
	<h2 class="popup-msg__title">{{ header }}</h2>
	<p class="popup-msg__msg">
		{{ message }}
	</p>
</div>
